import React from "react"
import { Button as BootStrapButton } from "react-bootstrap"
import styled from "styled-components"

const Button = styled(BootStrapButton)`
`

export default props => {
    return <Button
    {...props}
        className="mx-5 d-flex justify-content-between"
        disabled={props.disabled || props.loading}
        onClick={props.onClick}>
        {
            props.loading
                ? props.loadingText || props.title
                : props.title
        }
        <spa>
            <i className={`d-none fas fa-spinner fa-spin ${props.loading ? 'd-block ml-1 mt-1 ml-3' : ''}`}></i>
        </spa>
    </Button>
}


// WEBPACK FOOTER //
// ./src/_components/LoadingButton/index.jsx